import { categories as defaultCategories } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories';
import type { Category, GoalSchema } from 'containers/admin/clients/client/tabs-components/goals-tab/types';

const retentionToplineCategory: Category = {
  name: 'Topline',
  details: {
    required: true,
    associatedPropertyName: 'focusArea',
    displayName: 'Focus Area',
    options: [
      {
        value: 'Retention rate',
        label: 'Retention rate',
      },
    ],
  },
};

const categories: Category[] = [
  retentionToplineCategory,
  ...defaultCategories.filter((category) => category.name !== 'Topline'),
];

export const Retention: GoalSchema = {
  Retention: {
    subType: null,
    valueType: 'PERCENT',
    categories,
  },
};
